import { useRef, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

import Dropdown from "components/OptionsCard/Dropdown";
import { Option } from "components/OptionsCard/typings";

import styles from "./radix.module.scss";

interface Props {
  options: Option[];
}

// Menu „więcej" (kebab) wiersza dokumentu RADIX — wzorzec OutgoingRowMenu z biura
// podawczego (współdzielony Dropdown kotwiczony do refWrapper). Toolbox Magistratu
// (Edytuj / Drukuj / Kopie / Przekaż… / Usuń) pokazywał się po najechaniu na wiersz;
// tutaj to samo siedzi w menu wiersza.
const RadixRowMenu = ({ options }: Props) => {
  const [open, setOpen] = useState(false);
  const refWrapper = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.rowMenu}>
      <div
        ref={refWrapper}
        className={styles.rowMenuTrigger}
        title="Więcej"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        onDoubleClick={(e) => e.stopPropagation()}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      {open && (
        <Dropdown
          toggle={() => setOpen(false)}
          options={options.filter((o) => o.isEnabled)}
          refWrapper={refWrapper}
          rightSide={true}
          scrollWrapper={refWrapper}
          showOptions={open}
          selectedElements={[]}
          setSelectedElements={() => {}}
        />
      )}
    </div>
  );
};

export default RadixRowMenu;
